import React from 'react';
import '../App.css';
import flow from './menuImages/flow.jpg';

const Flow= ()=>{
    return(
      <div className="screen" style={{backgroundImage:'url('+flow+')'}}>
      </div>
    );
}
export default Flow;